import logo from "./images/sbc_25.webp";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import "./navFooter.scss";
import { useNavigate } from "react-router-dom";
import wings from "./images/PMW_White_Wings.webp";
import Moah from '../components/images/MOAH.webp'

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer>
      <section className="social__media">
        <section className="footer__icons">
          <a
            href="https://www.facebook.com/scottishbusinessconference"
            target="_blank"
            rel="noreferrer"
            aria-label="Visit Scottish Business Conference on Facebook"
          >
            <FacebookIcon className="icon" fontSize="large" />
          </a>

          <a
            href="https://www.instagram.com/scottishbusinessconference"
            target="_blank"
            rel="nonreferrer"
            aria-label="Visit Scottish Business Conference on Instagram"
          >
            <InstagramIcon className="icon" fontSize="large" />
          </a>
        </section>
        <section className="links">
          <a
            href="https://drive.google.com/file/d/1CjfD_kNyucE9xzJhjZSRAe58R1Y9Owt1/view"
            target="_blank"
            rel="nonreferrer"
          >
            <strong>T & C's</strong>
          </a>
          <a
            href="https://scottishbusinessconference.com/privacy-policy"
            target="_self"
            rel="nonreferrer"
          >
            <strong>Privacy Policy</strong>
          </a>
        </section>
      </section>
      <section className="logos">
        <img
          src={logo}
          alt="Scottish Business Conference"
          className="sbc__logo"
          onClick={() => navigate("/")}
        />
        <section className="column">
          <strong>Event Location</strong>
          <p>36 Cambridge Street,</p>
          <p>Glasgow, G2 3HN</p>
        </section>
        <a href="https://paulmcfaddenwealth.com" target="_blank">
          <img
            src={wings}
            alt="Paul McFadden Wealth Ltd"
            className="pmw__logo"
            width="100%"
          />
        </a>
        <a href="https://moahmedia.com" target="_blank">
          <img
            src={Moah}
            alt="MOAH Media Logo"
            className="moah__logo"
            width="100%"
          />
        </a>
      </section>
    </footer>
  );
}
